import { createLogger } from "./logger";
const logger = createLogger("loadScript");
async function loadScript(src, window, async = true, append = true) {
    return new Promise((resolve, reject) => {
        const w = window;
        if (w) {
            logger.logInfo(`Loading script ${src}, append to head: ${append}`);
            const scriptE = w.document.createElement("script");
            scriptE.setAttribute("src", src);
            scriptE.setAttribute("async", async.toString());
            const { head } = w.document;
            if (append) {
                head.appendChild(scriptE);
            }
            else {
                head.insertBefore(scriptE, head.firstElementChild);
            }
            scriptE.addEventListener("load", () => {
                logger.logInfo(`Script ${src} load finished`);
                resolve();
            }, false);
        }
        else {
            reject(new Error(`Unable to load script ${src}`));
        }
    });
}
export default loadScript;
//# sourceMappingURL=loadscript.js.map